import React from 'react';
import {graphql} from 'react-relay';
import {MODAL_TYPE, showModal} from '../../../shared/components/modals/generic_modal_conductor';
import {ModalProps} from '../../../shared/components/modals/types';
import {CustomFieldDefinitionCreateModal, CustomFieldDefinitionCreateModalInput} from './CustomFieldDefinitionCreateModal';
import {CustomFieldDefinitionEditModal, CustomFieldDefinitionEditModalInput} from './CustomFieldDefinitionEditModal';
import type {CustomFieldDefinitionModalQuery$data as CustomFieldDefinitionModalQueryResponse} from './__generated__/CustomFieldDefinitionModalQuery.graphql';

type CustomFieldDefinitionModalInput = CustomFieldDefinitionCreateModalInput | CustomFieldDefinitionEditModalInput;

export const showCustomFieldDefinitionModal = (props: CustomFieldDefinitionModalInput): void =>
	showModal({
		type: MODAL_TYPE.CUSTOM_FIELD_DEFINITION,
		...props,
	});

const isUpdating = (props): props is ModalProps<CustomFieldDefinitionEditModalInput> => {
	return !!props.id;
};

type CustomFieldDefinitionModalProps = ModalProps<CustomFieldDefinitionModalInput & CustomFieldDefinitionModalQueryResponse>;

export const CustomFieldDefinitionModal = ({viewer, ...props}: CustomFieldDefinitionModalProps): React.JSX.Element | null => {
	if (!viewer?.company) return null;

	return isUpdating(props) ? (
		<CustomFieldDefinitionEditModal {...props} viewer={viewer} company={viewer.company} />
	) : (
		<CustomFieldDefinitionCreateModal {...props} company={viewer.company} />
	);
};

export const CustomFieldDefinitionModalQuery = graphql`
	query CustomFieldDefinitionModalQuery($customFieldId: ID, $hasCustomFieldId: Boolean!) {
		viewer {
			actualPersonId
			component(name: "custom_field_definition_modal")
			company {
				...CustomFieldDefinitionCreateModal_company
				...CustomFieldDefinitionEditModal_company
			}
			...CustomFieldDefinitionEditModal_viewer @arguments(id: $customFieldId) @include(if: $hasCustomFieldId)
		}
	}
`;
